<template>
  <CoursesList :courses="courses" />
</template>

<script>
import GlobalMixin from "@/GlobalMixin";
import CoursesList from "../../components/NewReservation/CoursesList.vue";

export default {
  name: "CoursesView",
  mixins: [GlobalMixin],
  components: { CoursesList },
  data() {
    return {
      courses: [],
    };
  },
  mounted() {
    this.getTutorDetails();
  },
  methods: {
    /**
     * Get all details of a specific tutor
     */
    getTutorDetails() {
      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}tutor/detail/${this.$route.params.id}/`,
          {},
          this.headers
        )
        .then((res) => {
          this.courses = res.data.data.tutor.courses;
        });
    },
  },
  watch: {
    /**
     * Watch for language change
     */
    ["$i18n.locale"]() {
      this.headers.headers["accept-language"] = localStorage.lang;
      this.getconfigurations();
      this.getTutorDetails();
    },
  },
};
</script>
